import { render } from "./activation_report.vue?vue&type=template&id=cffdb6a2"
import script from "./activation_report.vue?vue&type=script&lang=js"
export * from "./activation_report.vue?vue&type=script&lang=js"

import "./activation_report.vue?vue&type=style&index=0&id=cffdb6a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__